import { useEffect, useState } from "react";

export default function useWindowSize() {
	const [size, setWindowSize] = useState({
		width: window?.innerWidth || 0,
		height: window.innerHeight || 0,
	});

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useEffect(() => {
		const _setWindowSize = () => {
			setWindowSize({
				width: window?.innerWidth || 0,
				height: window.innerHeight,
			});
		};
		window.addEventListener("resize", _setWindowSize);
		return () => {
			window.removeEventListener("resize", _setWindowSize);
		};
	}, []);

	return {
		...size,
		isTablet: size.width <= 1024,
		isPhone: size.width <= 599,
		isDesktop: size.width >= 1324,
	};
}
